import { createClient } from '@supabase/supabase-js';
import { Database } from './database.types';

// Add try/catch to handle potential environment variable errors
let supabase: ReturnType<typeof createClient<Database>> | null = null;

try {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

  if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Missing Supabase environment variables');
    throw new Error('Missing Supabase environment variables');
  }

  supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      storageKey: 'sb-auth-token',
      storage: window.localStorage
    },
  });
  
  console.log('Supabase client initialized successfully');
} catch (error) {
  console.error('Failed to initialize Supabase client:', error);
}

export { supabase };

/**
 * Wrapper function to handle PostgreSQL errors in a standardized way
 */
export async function handleSupabaseRequest<T>(
  promise: Promise<{ data: T | null; error: Error | null }>
): Promise<T> {
  const { data, error } = await promise;
  
  if (error) {
    console.error('Supabase request failed:', error);
    
    throw new Error(`Database operation failed: ${error.message}`);
  }
  
  if (data === null) {
    throw new Error('No data returned from database');
  }
  
  return data;
} 